module.exports = __webpack_public_path__ + "static/media/SourceSansPro-LightItalic.54e87ded.ttf";